import { Injectable } from "@angular/core";
import { SessionService } from "./session.service";
import { PermissionActions } from "../enum/app-modules.enum";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private sessionService: SessionService) {}

  private permissions: any[] = [];
  private roles: any[] = [];

  hasAnyPermission(allowedPermissions: string[]): boolean {
    if (!this.permissions.length) {
      const claims = this.sessionService.getClaims();
      if (claims) {
        this.setRolesAndPermissions(claims);
      }
    }

    return this.permissions.find((permission) =>
      allowedPermissions.includes(permission)
    );
  }

  hasAnyRole(allowedRoles: string[]): boolean {
    if (allowedRoles.length > 0) {
      return this.roles.some((role) => allowedRoles.includes(role));
    } else {
      return true;
    }
  }

  hasPermission(permission: string): boolean {
    if (!this.permissions.length) {
      const claims = this.sessionService.getClaims();
      if (claims) {
        this.setRolesAndPermissions(claims);
      } else {
        this.sessionService.logout();
      }
    }
    return this.permissions.includes(permission);
  }

  get getPermission(): any[] {
    return this.permissions;
  }

  setRolesAndPermissions(claims: any[]): void {
    this.permissions = claims
      .filter((claim) => claim.type === "Permission")
      .map((claim) => claim.value);
    this.roles = claims
      .filter((claim) => claim.type === "role")
      .map((claim) => claim.value);
  }

  getPermissionKey(permission: string): string {
    const parts = permission.split(".");
    return parts[0];
  }

  /**
   * Checks if the logged-in user is an admin.
   *
   * @returns {boolean} True if the user is an admin, false otherwise.
   */
  isAdmin(): boolean {
    return this.roles.includes("Admin");
  }
}
